module.exports = __webpack_public_path__ + "media/assets/good_at/Azure-769b278fd274f115c48ba462c0055aea.png";